var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / travel_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707784",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E535C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-travel_gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2795156,22.6667181 C10.5186932,22.6667181 10.7395194,22.5383809 10.8582537,22.330901 L15.2378728,14.6666795 L19.9999807,14.6666795 C21.4728882,14.6666795 24,13.4729075 24,12 C24,10.5270925 21.4728882,9.33332048 19.9999807,9.33332048 L15.2378728,9.33332048 L10.8587013,1.66909897 C10.765846,1.50692269 10.5556044,1.37144497 10.3614106,1.34010955 L10.2795156,1.33328192 L7.55033576,1.33328192 C7.10742184,1.33328192 6.78784022,1.75703071 6.90950422,2.1828547 L8.95244212,9.33332048 L4.66657349,9.33332048 L2.86655667,6.93332519 C2.74074226,6.76539632 2.54282464,6.66664096 2.33322891,6.66664096 L0.66696111,6.66664096 C0.233202509,6.66664096 -0.0851177105,7.07415432 0.0203108575,7.4949734 L1.33322409,12 L0.0203108575,16.5050266 C-0.0851177105,16.9258457 0.233202509,17.333359 0.66696111,17.333359 L2.33322891,17.333359 C2.54323155,17.333359 2.74074226,17.2346037 2.86655667,17.0666748 L4.66657349,14.6666795 L8.95244212,14.6666795 L6.90950422,21.8166977 C6.78784022,22.2425624 7.10742184,22.6667181 7.55033576,22.6667181 L10.2795156,22.6667181 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelGray);
export default __webpack_public_path__ + "static/media/travel_gray.847f5893ec03bf5c7ca98a34f50c079a.svg";
export { ForwardRef as ReactComponent };